import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { Loader, MetricCard, EmptyState, Money } from "@/components/shared";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, LineChart, Line, CartesianGrid } from "recharts";
import { BarChart3, IndianRupee, Receipt, Percent } from "lucide-react";

export default function Analytics() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/manufacturer/analytics").then((r) => setA(r.data)).catch(() => setA({})); }, []);
  if (!a) return <Loader />;

  if (!a.total_orders) return (
    <div className="space-y-5">
      <h1 className="font-heading text-2xl font-semibold text-forest">Analytics</h1>
      <EmptyState title="Analytics will appear after your first completed order." icon={BarChart3} />
    </div>
  );

  return (
    <div className="space-y-6">
      <h1 className="font-heading text-2xl font-semibold text-forest">Analytics</h1>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <MetricCard label="Total Orders" value={<span className="num">{a.total_orders}</span>} icon={Receipt} accent />
        <MetricCard label="GMV" value={<Money value={a.gmv} />} icon={IndianRupee} accent />
        <MetricCard label="Avg Order Value" value={<Money value={a.aov} />} icon={Receipt} />
        <MetricCard label="Fees Paid" value={<Money value={a.fees_paid} />} icon={Percent} />
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        <div className="rounded-xl border border-border bg-card p-5">
          <p className="mb-4 font-heading text-lg font-medium text-forest">Revenue by month</p>
          <ResponsiveContainer width="100%" height={240}>
            <LineChart data={a.revenue_by_month}>
              <CartesianGrid strokeDasharray="3 3" stroke="#D0DFDA" />
              <XAxis dataKey="month" tick={{ fontSize: 11, fill: "#263126" }} /><YAxis tick={{ fontSize: 11, fill: "#263126" }} />
              <Tooltip formatter={(v) => money(v)} />
              <Line type="monotone" dataKey="revenue" stroke="#3D4A38" strokeWidth={2.5} dot={{ fill: "#819983" }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className="rounded-xl border border-border bg-card p-5">
          <p className="mb-4 font-heading text-lg font-medium text-forest">Top products (units)</p>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={a.top_products}>
              <CartesianGrid strokeDasharray="3 3" stroke="#D0DFDA" />
              <XAxis dataKey="name" tick={{ fontSize: 10, fill: "#263126" }} interval={0} /><YAxis tick={{ fontSize: 11, fill: "#263126" }} />
              <Tooltip />
              <Bar dataKey="units" fill="#819983" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="rounded-xl border border-border bg-card p-5">
        <p className="mb-3 font-heading text-lg font-medium text-forest">Sales by state</p>
        {a.sales_by_state.length === 0 ? <p className="text-sm text-ink/50">No data</p> : (
          <div className="space-y-2">
            {a.sales_by_state.map((s) => (
              <div key={s.state} className="flex items-center justify-between text-sm"><span className="text-ink/70">{s.state}</span><Money value={s.value} className="text-forest" /></div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
